const userSelectors = function() {
  const self = {};

  // selects user out of the root state shape
  // state.products
  const _select = function(state) {
    return state.user;
  };

  // exposes the private method but gives flexability to
  // be able to construct the shape of the user
  // object if the root ever changes shape and other pages need
  // the older shape
  self.selectUser = function(state) {
    return _select(state);
  };

  // select current users info
  const _selectInfo = function(state) {
    const root = _select(state);

    return root.info;
  };

  // select current users map sets
  self.selectMapSets = function(state) {
    const root = _select(state);

    return root.mapSets;
  };

  self.selectAckEnabled = function(state) {
    const info = _selectInfo(state);

    return info.ackEnabled;
  };

  self.selectPreferences = function(state) {
    const info = _selectInfo(state);

    return info.preferences;
  };

  // convenince of selecting both first and last name and concating
  self.selectFullName = function(state) {
    const info = _selectInfo(state);

    return `${info.firstName} ${info.lastName}`;
  };

  self.selectRoleId = function(state) {
    const info = _selectInfo(state);

    return info.roleId;
  };

  self.selectLocationSetId = function(state) {
    const info = _selectInfo(state);

    return info.locationSetId;
  };

  return self;
};

export default userSelectors();
